import { createContext, useContext, useEffect } from "react";
import type { Id } from "@convex/_generated/dataModel";

/**
 * Where a file dropped anywhere in the app goes. The lesson dialog registers
 * itself while it is open; with nothing registered the upload is matched to
 * the timetable by the file's own time.
 */
export interface DropTarget {
  lessonId: Id<"lessons">;
  /** "Biology · Tue 29 Sep" - the overlay names it so a drop is never a guess. */
  label: string;
}

export interface DropTargetApi {
  /** Returns the unregister function. The most recent registration wins. */
  register: (target: DropTarget) => () => void;
}

export const DropTargetContext = createContext<DropTargetApi | null>(null);

/** While the calling component is mounted, drops attach to this lesson. */
export function useFileDropTarget(lessonId: Id<"lessons">, label: string): void {
  const api = useContext(DropTargetContext);
  useEffect(() => {
    if (api === null) return;
    return api.register({ lessonId, label });
  }, [api, lessonId, label]);
}
